var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-ai-create-ques-quick" },
    [
      _c(
        "ai-textarea",
        {
          ref: "txtAsk",
          attrs: {
            maxlength: "10000",
            "hide-btn": "",
            placeholder: _vm.$t(
              "pc_biz_ote_tip_entercontent" /** 请输入内容 */
            ),
          },
          on: {
            save: function ($event) {
              return _vm.convertToQues()
            },
            focus: _vm.focusInput,
          },
          model: {
            value: _vm.inputTxt,
            callback: function ($$v) {
              _vm.inputTxt = $$v
            },
            expression: "inputTxt",
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "pc_biz_ote_lbl_enterbytemplate" /** 请按照要求格式输入： */
                    )
                  ) +
                  "\n      "
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "text" },
                  on: { click: _vm.openSelectStandardFormatExample },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pc_biz_ote_lbl_sample" /** 查看标准格式示例 */)
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "flex flex-shrink-0 mt16 flex-top" }, [
        _c("div", { staticClass: "flex-shrink-0 mr8 color-gray-10" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pc_biz_ote_lbl_questiontypesetas" /** 设为 */)) +
              "\n    "
          ),
        ]),
        _c(
          "div",
          { staticClass: "yxtbiz-ai-break-tags" },
          [
            _vm._l(_vm.keywords.quesType, function (kw, index) {
              return [
                _c(
                  "yxt-button",
                  {
                    key: kw,
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.addType(0, index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(kw.replace("[", "").replace("]", "")) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "flex flex-shrink-0" }, [
        _c("div", { staticClass: "flex-shrink-0 mr8 color-gray-10" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pc_biz_ote_lbl_queslevel" /** 难度 */)) +
              "\n    "
          ),
        ]),
        _c(
          "div",
          { staticClass: "yxtbiz-ai-break-tags" },
          [
            _vm._l(_vm.keywords.levelTypeSorted, function (kw, index) {
              return [
                _c(
                  "yxt-button",
                  {
                    key: kw,
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.addType(1, index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(kw.replace("[", "").replace("]", "")) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "flex flex-shrink-0 color-gray-7" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.$t(
                "pc_biz_ote_lbl_notemousercursor" /** 注：把鼠标光标放置某个题干后，然后点击上述的题型 */
              )
            ) +
            "\n  "
        ),
      ]),
      _c(
        "yxt-button",
        {
          staticClass: "yxtbiz-ai-create-ques-btn flex-g-1 mt16",
          attrs: { type: "primary", size: "large", disabled: !_vm.inputTxt },
          on: {
            click: function ($event) {
              return _vm.convertToQues()
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("pc_biz_ote_btn_genques" /** 生成试题 */)) +
              "\n  "
          ),
        ]
      ),
      _c("ques-standard-format-example-a-i", {
        attrs: { states: _vm.selectStandardFormatExample },
        on: { closeStandardFormatExample: _vm.closeStandardFormatExample },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }